import { render, staticRenderFns } from "./add_shoplist_syr.vue?vue&type=template&id=67a6f56d&scoped=true&"
import script from "./add_shoplist_syr.vue?vue&type=script&lang=js&"
export * from "./add_shoplist_syr.vue?vue&type=script&lang=js&"
import style0 from "./add_shoplist_syr.vue?vue&type=style&index=0&id=67a6f56d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a6f56d",
  null
  
)

export default component.exports